import React, { PureComponent } from "react";

class Container extends PureComponent {
  renderToggle() {
    return this.renderToggleDecorator();
  }

  renderToggleDecorator() {
    const { style, decorators, node } = this.props;
    return <decorators.Toggle style={style.toggle} node={node} />;
  }

  render() {
    const { style, decorators, terminal, onClick, node } = this.props;
    return (
      <div onClick={onClick} style={node.active ? { ...style.container } : { ...style.link }}>
        {!terminal ? this.renderToggle() : null}
        <decorators.Header node={node} style={style.header} />
      </div>
    );
  }
}

export default Container;
